import { styled } from "styled-components";

export const MainSectionWrapper = styled.div`
  height: 100vh;
  background: #000;
  color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
`;
